import { styled } from '@material-ui/core';
import React from 'react';

const StyledDiv = styled('div')({
  height: '100%',
  '& [class^=MuiPaper-root], & [class^=MuiCard-root]': {
    height: '100% !important',
    marginBottom: 0,
  },
  '& > [class^=MuiBox]': {
    height: '100%',
  },
});

export default function CardWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return <StyledDiv>{children}</StyledDiv>;
}
